import { Checkbox } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const StyledCheckBox = styled(Checkbox)`
    & > span:first-of-type {
        width: 20px;
        height: 20px;
        border: 1px solid black;
        border-radius: 4px;
    }

    & > span:first-of-type[data-checked] {
        background: ${({ theme }) => theme.COLOR.pink[200]};
        border: 1px solid ${({ theme }) => theme.COLOR.pink[200]};
    }
`;
